import { Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom"; // Make sure you have react-router-dom installed
import "./Breadcrumb.css";
import { ArrowLeft } from "lucide-react";
import BackIcon from "../../Images/icons/components/Back-icon";

const CustomBreadcrumb = ({ items = [], onBack, userRole }) => {
     const navigate = useNavigate();
  
  const getLinkForItem = (item, index) => {

    if (index === 0) {
      return null;
    }
 
    if (item === "Resume Builder") {

        console.log("userRole in breadcrumb:", userRole);
      if (userRole === "ROLE_HR") {
        return "/dashboardHr";
      } else {
        return "/dashboard";
      }
    }
     if (item === "Dashboard-HR") {
          return "/dashboardHr";

    }
    

    
    return null; 
  };

    const getBackPath = () => {
    const currentPage = items[items.length - 1]; // Get the last item (current page)
    
    // Define the navigation flow
    const navigationFlow = {
      "Personal Info": userRole === "ROLE_HR" ? "/dashboardHr" : "/dashboard",
      "Education": "/personalInfo",
      "Professional Experience": "/education",
      "Skills": "/professionalExperience",
      "Professional Summary": "/skills"
    };
    
    return navigationFlow[currentPage] || (userRole === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  };

  const handleBackClick = () => {
    const backPath = getBackPath();
    navigate(backPath);
  };

  const breadcrumbItems = ["Plasma", ...items];

  return (
    <div style={{ display: "flex" }}>
      <BackIcon
        
        className="breadcrumb-back"
        onClick={handleBackClick}
        style={{ cursor: "pointer"}}
      />

      <Breadcrumb separator="/" className="custom-breadcrumb">
        {breadcrumbItems.map((item, index) => {
          const link = getLinkForItem(item, index);
          
          return (
            <Breadcrumb.Item key={index}>
              {link ? (
                <Link to={link} className="breadcrumb-link">
                  {item}
                </Link>
              ) : (
                <span>{item}</span>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default CustomBreadcrumb;